import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SelectItem } from "primeng/api";
import { ListaService } from "../../../../_services/lista.service";
import { NavService } from "../../../../_services/_nav.service";
import { Producto } from "../../../../_models/producto";
import { ProductoRestriccionSubdestino } from "../../../../_models/producto-restriccion-subdestino";
import { ProductoRestriccionSubdestinoService } from "../../../../_services/producto-restriccion-subdestino.service";
import { forkJoin } from "rxjs";
import { EstructuraFisica } from "../../../../_models/estructura-fisica";
import { ListaItem } from "../../../../_models/lista-item";
import { EstructuraFisicaService } from "../../../../_services/estructura-fisica.service";

@Component({
  selector: "app-producto-restriccion-subdestino",
  templateUrl: "./producto-restriccion-subdestino.component.html",
  styleUrls: ["./producto-restriccion-subdestino.component.css"],
})
export class ProductoRestriccionSubdestinoComponent implements OnInit {
  @Input() producto: Producto;
  @Input() verDetalle: boolean = false;

  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  formulario: FormGroup;
  lisEstructurasFisica: SelectItem[] = [];
  lisEstructurasFisicaTodos: EstructuraFisica[] = [];
  lisDestinos: SelectItem[] = [];
  lisDestinosTodos: ListaItem[] = [];
  lisSubdestinos: SelectItem[] = [];
  lisSubdestinosTodos: ListaItem[] = [];
  lisProductosRestriccionesSubdestinos: ProductoRestriccionSubdestino[] = [];
  lisProductosRestriccionesSubdestinosTodos: ProductoRestriccionSubdestino[] =
    [];
  columnas: any[];

  constructor(
    private fb: FormBuilder,
    private navServicio: NavService,
    private lisServicio: ListaService,
    private productoRestriccionSubdestinoService: ProductoRestriccionSubdestinoService,
    private estructuraFisicaService: EstructuraFisicaService
  ) {}

  ngOnInit() {
    this.cargarColumnas();
    this.cargaInicial();
  }

  /* cargar columnas */
  cargarColumnas() {
    this.columnas = [
      {
        field: "estructuraFisica",
        header: this.navServicio.buscarMensaje("PRODUCTO.LBL_OFICINA"),
        sort: false,
      },
      {
        field: "destino",
        header: this.navServicio.buscarMensaje("PRODUCTO.LBL_DESTINO"),
        sort: false,
      },
      {
        field: "subdestino",
        header: this.navServicio.buscarMensaje("PRODUCTO.LBL_SUBDESTINO"),
        sort: false,
      },
    ];

    /* cuando no sea detalle agregar la columna de acciones */
    if (!this.verDetalle) {
      this.columnas.push({
        field: "det",
        header: this.navServicio.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      });
    }
  }

  /* carga inicial del componente - se cargan lo que no va a variar */
  cargaInicial() {
    forkJoin(
      this.lisServicio.getMasterDetails("ListasDestinosProductos"),
      this.lisServicio.getMasterDetails("ListasSubDestinosProductos"),
      this.estructuraFisicaService.getAllEnabled()
    ).subscribe(([lisDestinos, lisSubdestinos, lisEstructurasFisica]) => {
      this.lisDestinosTodos = lisDestinos;
      this.lisSubdestinosTodos = lisSubdestinos;
      this.lisEstructurasFisicaTodos = lisEstructurasFisica;
      this.cargarFormulario();
      this.cargarListas();
    });
  }

  /* cargar las lista dicamicas del componente */
  cargarListas() {
    this.carInformacionInicial = true;
    this.lisProductosRestriccionesSubdestinosTodos = [];
    this.lisProductosRestriccionesSubdestinos = [];
    this.lisEstructurasFisica = [];
    this.lisSubdestinos = [];
    this.lisDestinos = [];
    forkJoin(
      this.productoRestriccionSubdestinoService.listadoPorProducto(
        this.producto.idProducto
      )
    ).subscribe(([lisProductosRestriccionesSubdestinos]) => {
      this.lisProductosRestriccionesSubdestinosTodos =
        lisProductosRestriccionesSubdestinos;
      this.lisProductosRestriccionesSubdestinosTodos.map((x) => {
        if (x.indicadorHabilitado) {
          this.lisProductosRestriccionesSubdestinos.push(x);
        }
      });

      /* filtrar listado de ofinicas */
      const destinosXSubdestinos =
        this.lisDestinosTodos.length * this.lisSubdestinosTodos.length;
      this.filtrarLista(
        this.lisProductosRestriccionesSubdestinos,
        this.lisEstructurasFisicaTodos,
        this.lisEstructurasFisica,
        destinosXSubdestinos,
        "idEstructuraFisica"
      );

      /* filtrar listado de destinos*/
      const oficinasXSubdestinos =
        this.lisEstructurasFisicaTodos.length * this.lisSubdestinosTodos.length;
      this.filtrarLista(
        this.lisProductosRestriccionesSubdestinos,
        this.lisDestinosTodos,
        this.lisDestinos,
        oficinasXSubdestinos,
        "idDestino"
      );

      /* filtrar listado de subdestino bloqueados */
      const oficinasXDestino =
        this.lisEstructurasFisicaTodos.length * this.lisDestinosTodos.length;
      this.filtrarLista(
        this.lisProductosRestriccionesSubdestinos,
        this.lisSubdestinosTodos,
        this.lisSubdestinos,
        oficinasXDestino,
        "idSubdestino"
      );
      this.carInformacionInicial = false;
      this.guardando = false;
    });
  }

  /* filtrar listas */
  filtrarLista(
    listaPadre: any,
    listaEntrada: any,
    listaSalida: any,
    multiplicador: number,
    campo: string
  ) {
    if (listaPadre.length > 0) {
      listaEntrada.map((x) => {
        let productosRestricciones;
        switch (campo) {
          case "idEstructuraFisica":
            productosRestricciones =
              this.lisProductosRestriccionesSubdestinos.filter(
                (pr) => pr.idEstructuraFisica === x.idEstructuraFisica
              ).length;
            if (productosRestricciones < multiplicador) {
              listaSalida.push({
                label: x.estructuraFisica,
                value: x.idEstructuraFisica,
              });
            }
            break;
          case "idDestino":
            productosRestricciones =
              this.lisProductosRestriccionesSubdestinos.filter(
                (pr) => pr.idDestinoProducto === x.idDestino
              ).length;
            if (productosRestricciones < multiplicador) {
              listaSalida.push({
                label: x.nombre,
                value: x.idLista,
              });
            }
            break;
          case "idSubdestino":
            productosRestricciones =
              this.lisProductosRestriccionesSubdestinos.filter(
                (pr) => pr.idSubDestinoProducto === x.idSubdestino
              ).length;
            if (productosRestricciones < multiplicador) {
              listaSalida.push({
                label: x.nombre,
                value: x.idLista,
              });
            }
            break;
          default:
            break;
        }
      });
    } else {
      listaEntrada.map((x) => {
        switch (campo) {
          case "idEstructuraFisica":
            listaSalida.push({
              label: x.estructuraFisica,
              value: x.idEstructuraFisica,
            });
            break;
          case "idDestino":
            listaSalida.push({
              label: x.nombre,
              value: x.idLista,
            });
            break;
          case "idSubdestino":
            listaSalida.push({
              label: x.nombre,
              value: x.idLista,
            });
            break;
          default:
            break;
        }
      });
    }
  }

  /* incializar formulario */
  cargarFormulario() {
    this.formulario = this.fb.group({
      idsEstructurasFisica: [[], [Validators.required]],
      idsDestinos: [[], [Validators.required]],
      idsSubdestinos: [[], [Validators.required]],
    });
  }

  /* guardar */
  async onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando = true;
      let registros = [];
      let bulk = [];
      this.f.idsEstructurasFisica.value.map((e) => {
        this.f.idsDestinos.value.map((d) => {
          this.f.idsSubdestinos.value.map((s) => {
            let registro = {} as ProductoRestriccionSubdestino;
            const existe = this.lisProductosRestriccionesSubdestinosTodos.find(
              (x) =>
                x.idEstructuraFisica === e &&
                x.idDestinoProducto === d &&
                x.idSubDestinoProducto === s
            );

            if (existe && !existe.indicadorHabilitado) {
              registro = existe;
              registro.indicadorHabilitado = true;
            } else if (!existe) {
              registro.idProducto = this.producto.idProducto;
              registro.idEstructuraFisica = e;
              registro.idDestinoProducto = d;
              registro.idSubDestinoProducto = s;
              registro.indicadorHabilitado = true;
            }

            if (registro && registro.indicadorHabilitado) {
              registros.push(registro);
            }
          });
        });
      });

      bulk = this.fraccionarBulkEnvio(registros);
      if (bulk.length > 0) {
        for (let index = 0; index < bulk.length; index++) {
          const element = bulk[index];
          await this.productoRestriccionSubdestinoService.bulk(element).toPromise();
        }

        const oficinasXDestinosXSubdestinos =
          this.f.idsEstructurasFisica.value.length *
          this.f.idsDestinos.value.length *
          this.f.idsSubdestinos.value.length;
        this.submitted = false;
        this.formulario.reset();
        if (oficinasXDestinosXSubdestinos != registros.length) {
          this.navServicio.setMesage(0, {
            severity: "info",
            summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
            detail: this.navServicio.buscarMensaje(
              "PRODUCTO.LBL_NOSEGUARDARONTODOSLOSREGISTRODEPRODUCTOSRESTRICCIONESSUBDESTINOS"
            ),
          });
        } else {
          this.navServicio.setMesage(1);
        }
        this.cargarListas();
      } else {
        this.formulario.reset();
        this.submitted = false;
        this.guardando = false;
        this.navServicio.setMesage(0, {
          severity: "info",
          summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
          detail: this.navServicio.buscarMensaje(
            "PRODUCTO.LBL_NOSEGUARDARONTODOSLOSREGISTRODEPRODUCTOSRESTRICCIONESSUBDESTINOS"
          ),
        });
      }
    }
  }

  /* fraccionar la lista del bulk en pedazos mas pequenos */
  fraccionarBulkEnvio(lista: any[]) {
    let listaDevuelta: any[] = [];
    const LONGITUD_PEDAZOS = 5000; /* Loingitud de cada pedazo */
    for (let i = 0; i < lista.length; i += LONGITUD_PEDAZOS) {
      let pedazo = lista.slice(i, i + LONGITUD_PEDAZOS);
      listaDevuelta.push(pedazo);
    }
    return listaDevuelta;
  }

  /* controls del formulario */
  get f() {
    return this.formulario.controls;
  }

  /* inhabilitar registro */
  inhabilitar(row: ProductoRestriccionSubdestino) {
    row.indicadorHabilitado = false;
    this.guardando = true;
    this.productoRestriccionSubdestinoService.actualizar(row).subscribe(
      (res) => {
        this.navServicio.setMesage(1);
        this.cargarListas();
      },
      (error) => {
        this.navServicio.setMesage(2);
        this.guardando = false;
      }
    );
  }
}
